function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chain, forEach } from 'lodash';
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos';
import { CVModel } from 'src/_candidato/data/cv/CVModel';
import { CurriculumService } from 'src/_candidato/public/services/CurriculumService';
import { $candidatoPublicMod } from '../../candidato-public-mod';
var StartFormComponentCtrl = /*#__PURE__*/function () {
  StartFormComponentCtrl.$inject = ["$scope", "$element", "$timeout", "$q", "$log", "vcRecaptchaService", "CurriculumService"];
  function StartFormComponentCtrl($scope, $element, $timeout, $q, $log, vcRecaptchaService, CurriculumService) {
    _classCallCheck(this, StartFormComponentCtrl);
    _defineProperty(this, "aceptarTerminos", true);
    _defineProperty(this, "aceptarRecaptcha", true);
    _defineProperty(this, "modalAceptar", true);
    _defineProperty(this, "$ready", false);
    _defineProperty(this, "textosCV", false);
    _defineProperty(this, "errorcapt", false);
    _defineProperty(this, "erroraccept", false);
    _defineProperty(this, "form", {
      recapResponse: '',
      dataaccept: false
    });
    _defineProperty(this, "testCV", 7);
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "$success", false);
    _defineProperty(this, "$errorSesion", false);
    _defineProperty(this, "$errorEnvio", false);
    _defineProperty(this, "$errorEnvioMsg", '');
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$q = $q;
    this.$log = $log;
    this.vcRecaptchaService = vcRecaptchaService;
    this.CurriculumService = CurriculumService;
  }
  return _createClass(StartFormComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[StartFormComponentCtrl] onInit');
      this.textosCV = this.appConfig.introCv;
      this.aceptarTerminos = this.appConfig.acceptTerms || this.menuopt.accLo;
      this.aceptarRecaptcha = this.appConfig.acceptRecaptcha || this.menuopt.accRc;
      this.modalAceptar = this.aceptarRecaptcha || this.aceptarTerminos;

      // this.__init()
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.cuestionario && changes.cuestionario.currentValue) {
        this.__init();
      }
    }
  }, {
    key: "__init",
    value: function __init() {
      this.$ready = false;
      this.cvmodel = new CVModel();
      this.$success = false;
      this.$loading = false;
      this.erroraccept = false;
      this.errorcapt = false;
      this.form = {
        recapResponse: '',
        dataaccept: false
      };

      // forzar un cambio de modelo
      this.$ready = true;
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      var _this = this;
      this.$timeout(function (_) {
        var modalInstance = _this.$element.find('#modal-send').modal({
          onCloseEnd: function onCloseEnd() {
            return $('body').removeClass('modal-open').css('overflow', 'auto');
          }
        });
        _this.modalInstance = M.Modal.getInstance(modalInstance[0]);
      }, 1000);
    }
  }, {
    key: "sendCuestionario",
    value: function sendCuestionario() {
      if (!this.cvmodel.validar()) {
        this.$log.info('Validación falla');
        return;
      }
      this.$success = false;
      this.$errorSesion = false;
      this.$errorEnvio = false;
      this.$errorEnvioMsg = '';
      if (this.modalAceptar) {
        if (this.aceptarRecaptcha) {
          this.vcRecaptchaService.reload();
        }
        this.form.dataaccept = false;
        this.erroraccept = false;
        this.errorcapt = false;
        this.modalInstance.open();
        $('body').addClass('modal-open');
      } else {
        this.modalInstance.open();
        $('body').addClass('modal-open');
        this.sendCuestionarioConfirmed();
      }
      this.$log.debug(this.__req());
    }
  }, {
    key: "sendCuestionarioConfirmed",
    value: function sendCuestionarioConfirmed() {
      var _this2 = this;
      var pregFiles = this.cvmodel.files();
      this.$loading = true;
      this.CurriculumService.sendCv(this.__req(), this.accesoPublico).then(function (cvStateResponse) {
        var url = BASE_CANDIDATO_API + "api/_cv/n/".concat(cvStateResponse.tkn, "/f?_f=");
        var fd = new FormData();
        fd.append('tkn', cvStateResponse.tkn);
        fd.append('t', cvStateResponse._t);

        // al guardar, enviar todos los files
        chain(pregFiles).forEach(function (pregFile) {
          chain(pregFile.filesEnviar()).forEach(/*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return _this2.enviafile(file, pregFile, url, fd);
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).value();
        }).value();
        _this2.$success = true;
      }, function (err) {
        // alert('Ha habido un problema, por favor vuelva a intentarlo')

        // FIXME :gestionar el error

        _this2.form.dataaccept = false;
        _this2.$log.warn('error al enviar el cuestionario', err);
        if (!_this2.accesoPublico && (err === null || err === void 0 ? void 0 : err.status) == 403) {
          _this2.$errorSesion = true;
        } else {
          // gestionar el error

          _this2.$errorEnvio = true;
          _this2.$errorEnvioMsg = 'There was a problem, please try again';
        }
        if (_this2.aceptarRecaptcha && _this2.vcRecaptchaService) {
          _this2.vcRecaptchaService.reload();
        }
      })["finally"](function () {
        _this2.$loading = false;
      });
    }
  }, {
    key: "sendCuestionarioAgree",
    value: function sendCuestionarioAgree() {
      // this.vcRecaptchaService.execute();

      this.$log.info('login', this.form);
      this.erroraccept = this.aceptarTerminos && !this.form.dataaccept;
      if (this.erroraccept) return;
      if (this.aceptarRecaptcha) {
        var recapResponse = this.vcRecaptchaService.getResponse(); // returns the string response
        this.$log.info('recaptcha', recapResponse);
        if (recapResponse == '') {
          this.errorcapt = true;
          return;
        }
      }
      this.sendCuestionarioConfirmed();
    }
  }, {
    key: "relogin",
    value: function relogin() {
      // cerrar el modal de envío
      this.modalInstance.close();
      window.open('/?_back=1#!/c/priv/login', '_target=_blank');
    }
  }, {
    key: "testSendFiles",
    value: function testSendFiles() {
      var _this3 = this;
      var pregFiles = this.cvmodel.files();
      var url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f?idcv=' + this.testCV;

      // al guardar, enviar todos los files
      forEach(pregFiles, function (pregFile) {
        forEach(pregFile.filesEnviar(), /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return _this3.enviafile(file, null, url, new FormData());
                case 1:
                  _this3.$log.info('== Enviado!!!');
                case 2:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "testClose",
    value: function testClose() {
      window.open('/?_back=1&dev=1#!/c/priv/login', '_target=_blank');
    }
  }, {
    key: "enviafile",
    value: function enviafile(f, cvpreg, url, fd) {
      var $p = this.$q.defer();
      f.url = url + encodeURI(f.file.name);
      f.formData = [fd, this._formDataPreg(cvpreg)];
      f.onComplete = function () {
        $p.resolve();
      };
      f.upload();
      return $p.promise;
    }
  }, {
    key: "_formDataPreg",
    value: function _formDataPreg(cvpreg) {
      if (!cvpreg) return new FormData();
      var fd = new FormData();
      fd.append('qref', cvpreg.idqref);
      fd.append('idx', cvpreg.idx);
      return fd;
    }
  }, {
    key: "__req",
    value: function __req() {
      var req = {
        peticion: {
          idform: this.cuestionario.infoForm.idf,
          idmen: this.menuopt.idm
        },
        resplist: this.cvmodel.respuestas(),
        verify: ''
      };
      this.$log.info('confirm', req);
      return req;
    }
  }, {
    key: "rellenaTest",
    value: function rellenaTest() {
      // para cada respuesta, rellenar valor de prueba
      this.cvmodel.__rellenaTest();
    }
  }]);
}();
$candidatoPublicMod.component('startForm', {
  bindings: {
    // empresa: "<",
    cuestionario: '<',
    params: '<',
    menuopt: '<',
    appConfig: '<',
    accesoPublico: '<'
  },
  controller: StartFormComponentCtrl,
  template: require('./start-form.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-form/start-form.component.html"
});